<div class="de-dup-wrapper" [ngClass]="mat_fields_spinner ? 'permission-denied': '' ">
    <div class="dedup-header border-light-bottom px-8 py-4">
        <div class="header-wrapper">
            <div class="header-left">
                <h3 class="primary-text boldest-text">{{alertvarservice.dedupTitles.dedup_title}}</h3>
                <p class="primary-text content-m">{{alertvarservice.dedupTitles.dedup_context}}</p>
            </div>
            <div class="header-right">
                <div class="header-icons">
                    <mat-icon class="primary-text enable-action" (click)="close()">close</mat-icon>
                </div>
            </div>
        </div>
    </div>
    <div class="dedup-content border-light-bottom px-8 py-3">
        <div class="content-wrapper">
            <div class="groupBy">
                <div class="select-fields">
                    <div class="groupby-header">
                        <h4 class="primary-text boldest-text">{{alertvarservice.dedupTitles.group_alerts}}</h4>
                        <p class="primary-text content-m">{{alertvarservice.dedupTitles.groupby_context}}</p>
                    </div>
                    <div class="groupby-fields">
                        <ng-container *ngFor="let field of fields">
                            <div class="fields-wrapper p-4 radius-m enable-action" (click)="fieldsClick(field)" [ngClass]="fieldsCheck(field) ? 'border-report': 'border-light'">
                                <div class="fields-checkbox">
                                    <input type="checkbox" class="shadow-none enable-action" [checked]="fieldsCheck(field)">
                                </div>
                                <div class="fields-list ">
                                    <p class="content-m boldest-text primary-text ">{{field.disp }}</p>
                                    <div class="cardinality ">
                                        <p class="content-s lighter-text primary-text ">Cardinality = &nbsp;</p>
                                        <p class="content-s lighter-text primary-text ">{{field.cardinality}}</p>
                                    </div>

                                </div>

                            </div>
                        </ng-container>
                    </div>
                </div>
                <div class="groupby-time ">
                    <div class="time-header ">
                        <h4 class="primary-text boldest-text ">{{alertvarservice.dedupTitles.groupby_time}}</h4>
                        <p class="primary-text content-m ">{{alertvarservice.dedupTitles.time_context}}</p>
                    </div>
                    <div class="overlay-wrapper border-light p-2 radius-s">
                        <app-overlay-select placeHolder="Time" sort="true" [formControl]="alertvarservice.dedup_time" overlaycontainer="shadow-none border-none" fontsize="shadow-none border-none" [data]="alertvarservice.dedup_time_data"></app-overlay-select>
                    </div>
                </div>
                <div class="groupby-selected ">
                    <div class="selected-header ">
                        <h4 class="primary-text boldest-text ">{{alertvarservice.dedupTitles.selected}}</h4>
                    </div>
                    <div class="selected-content ">
                        <div class="selected-wrapper border-light primary-bg border-dashed p-4 ">
                            <div class="selected-left ">
                                <ng-container *ngFor="let chip of selected_fields ">
                                    <div class="chip border-report radius-m py-2 px-4 ">
                                        <p class="content-m selectable-text ">{{chip.disp }}</p>
                                        <mat-icon class="primary-text enable-action icon-xs " (click)="removeFields(chip)">close</mat-icon>
                                    </div>
                                </ng-container>
                                <p class="placeholder-text content-m lighter-text" *ngIf="!selected_fields.length">{{alertvarservice.dedupTitles.selected_placeholder}}</p>
                            </div>
                            <div class="selected-right" [ngClass]="!selected_fields.length ? 'permission-denied':''">
                                <mat-icon class="primary-text enable-action " (click)="removeAll()">close</mat-icon>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="results border-light-top mt-8 py-6" *ngIf="dedup_results.length">
                <div class="results-wrapper">
                    <div class="results-header">
                        <div class="header-left">
                            <h4 class="primary-text boldest-text">{{alertvarservice.dedupTitles.result_header}}</h4>
                            <p class="primary-text content-m">{{alertvarservice.dedupTitles.result_context}} {{getTimeDisp(dedupReq["timewindow"] ? dedupReq["timewindow"] : alertvarservice.dedup_time.value )}} {{alertvarservice.dedupTitles.window}}</p>
                        </div>
                        <div class="headers-right">
                            <div class="chip border-report radius-m py-2 px-4 ">
                                <p class="content-m selectable-text ">{{dedup_results.length}} {{dedup_results.length == 1 ? alertvarservice.dedupTitles.group_generated :alertvarservice.dedupTitles.groups_generated}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="results-body ">
                        <ng-container *ngIf="bulkMode">
                            <div class="bulk-mode">
                                <app-action-panel-bulk [data]="multi_data" (actionStatus)="updateAction($event)"></app-action-panel-bulk>
                            </div>
                        </ng-container>

                        <div class="results-wrapper">
                            <div class="table-wrapper border-light radius-m">
                                <table>
                                    <thead>
                                        <tr>
                                            <!-- <th></th> -->
                                            <th><input type="checkbox" class="shadow-none enable-action" [formControl]="selectAll"></th>
                                            <th *ngFor="let head of alertvarservice.dedup_th">{{head}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngFor="let group of dedup_results | custompagination :pagenumber:itemperpage.value ; index as i">
                                            <tr>
                                                <!-- <td>
                                                    <div class="add-btn radius-m border-light primary-text enable-action" (click)="open_actionPanel(i,group)">
                                                        <mat-icon>{{i == active_panel ? 'remove' : 'add'}}</mat-icon>
                                                    </div>
                                                </td> -->
                                                <td><input type="checkbox" class="shadow-none enable-action" (change)="groupClick($event,group)" [checked]="group.checked"></td>
                                                <td>{{group.timerange[0] | changetimezone : 'YYYY-MM-DD HH:mm:ss'}}</td>
                                                <td>{{group.timerange[1] | changetimezone : 'YYYY-MM-DD HH:mm:ss'}}</td>
                                                <td>
                                                    <div class="values-list">
                                                        <ng-container *ngFor="let items of group.fields |keyvalue:originalOrder">
                                                            <div class="list-items border-light primary-bg radius-m px-2 py-1">
                                                                <p class="primary-text content-m boldest-text">{{items.key}}:</p>
                                                                <div *ngIf="items.value" class="item-value">
                                                                    <p class="primary-text content-m">{{items.value}}</p>
                                                                </div>
                                                            </div>
                                                        </ng-container>
                                                    </div>
                                                </td>
                                                <td>{{group.alertCount}}</td>
                                                <td>{{group.eventCount}}</td>
                                                <td>
                                                    <!-- <div class="current_status px-2 content-m radius-m white-text enable-action" *ngIf="group.status == 0" (click)=acknowledgeClick(i,group)>
                                                        {{alertvarservice.dedupTitles.acknowledge}}
                                                    </div> -->
                                                    <div class="actions-list" [ngClass]="group.checked ? 'permission-denied':''">
                                                        <ng-container *ngFor="let action of getApplicableActions(group.status) |keyvalue:originalOrder">
                                                            <div class="current_status px-2 radius-m content-m  enable-action" *ngIf="!action.value.isDefault" [ngStyle]="alertvarservice.statusStyle[action.value.value]" (click)=actionClick(i,group,action.value)>
                                                                <mat-icon>{{action.value.icon}}</mat-icon>
                                                                <p class="m-0">{{action.value.actionDisp}}</p>
                                                            </div>
                                                        </ng-container>
                                                    </div>
                                                    <!-- <button *ngIf="group.status == 0" class="submit">Acknowledge</button> -->
                                                </td>
                                            </tr>
                                            <!-- <tr class="white-bg" *ngIf="i == active_panel">
                                                <td class="action-panel-td" colspan="8">
                                                    <div class="action-panel p-7 selected-list">
                                                        <ng-container>
                                                            <app-action-panel [data]="alert_dedup_data" (actionStatus)="updateAction($event)"></app-action-panel>
                                                        </ng-container>

                                                    </div>
                                                </td>
                                            </tr> -->
                                        </ng-container>
                                    </tbody>
                                </table>
                            </div>
                            <div class="pagination-wrapper mt-2">
                                <!-- <div class="body-top-col-3">
                                    <div class="arrow">
                                        <img class="icon-s" src="assets/rule/left-arrow.svg" (click)="intelpaginationTable_click(-1)" [ngClass]="pagenumber | disableAction:this.pagelength:-1:mat_fields_spinner">
                                    </div>
                                    <p class="primary-texts content-m">Page {{pagenumber}} of {{pagelength}}</p>
                                    <div class="arrow">
                                        <img class="icon-s" src="assets/rule/right-arrow.svg" (click)="intelpaginationTable_click(1)" [ngClass]="pagenumber | disableAction:pagelength:1:mat_fields_spinner">
                                    </div>
                                </div>

                                <div class="body-top-col-4">
                                    <ng-container *ngFor="let pagedat of alertvarservice.commondata.pagination | keyvalue">
                                        <p class="pagination-items-per-page content-m primary-texts">{{pagedat.key}}</p>
                                        <div class="itemperpage">
                                            <app-overlay-select [formControl]="itemperpage" [data]="pagedat.value" fontsize="input-m">
                                            </app-overlay-select>
                                        </div>

                                    </ng-container>
                                </div> -->
                                <div class="pagination-left border-light white-bg p-1 radius-m pr-3">
                                    <!-- <div class="page-number-container"></div> -->
                                    <div class="prev-page enable-action" (click)="intelpaginationTable_click(-1)" [ngClass]="pagenumber | disableAction:pagelength:-1:mat_fields_spinner">
                                        <mat-icon>chevron_left</mat-icon>
                                    </div>
                                    <div class="page-info">
                                        <p class="m-0 content-m primary-text boldest-text">Page {{pagenumber}} of {{pagelength}}</p>
                                    </div>
                                    <div class="next-page  enable-action" (click)="intelpaginationTable_click(1)" [ngClass]="pagenumber | disableAction:pagelength:1:mat_fields_spinner">
                                        <mat-icon>chevron_right</mat-icon>
                                    </div>
                                    <div class="itemsper-page-container">
                                        <p class="m-0 content-m primary-text boldest-text">Items per page:</p>
                                        <div class="items-per-page-list  enable-action">
                                            <app-overlay-select class="item-overlay" overlaycontainer="border-none shadow-none" [data]="alertvarservice.itemsPerpageValueList" [formControl]="itemperpage" sort="true"></app-overlay-select>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>



                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="dedup-footer p-3 ">
        <div class="footer">
            <button class="submit py-2" [ngClass]="selected_fields.length && alertvarservice.dedup_time.value? '' : 'permission-denied'" (click)="applyDedup()">{{alertvarservice.dedupTitles.apply_dedup}}</button>
            <button class="cancel py-2" (click)="close()">{{alertvarservice.dedupTitles.cancel}}</button>
        </div>
    </div>
</div>
<ng-container *ngIf="mat_fields_spinner">
    <div class="body-bottom-spinner">
        <mat-spinner class="spinner" diameter=20></mat-spinner>
    </div>
</ng-container>

<ng-template #actionpanel let-dialogRef="dialogRef">
    <mat-dialog-content class="p-0 m-0">
        <div class="dialog-container">
            <app-set-action-panel [data]="setActionInput"></app-set-action-panel>
        </div>
    </mat-dialog-content>
</ng-template>